import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../BasePanelPage";
import {PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {donateMobileState} from "../../../inline-donation/DonateMobileState";
import {LoadingSpinner} from "../../../../ui/LoadingSpinner";
import {DonateComponent} from "./components/DonateComponent";
import {MerchantButton} from "../../../../common/MerchantButton";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {INLINE_DONATION_URLS} from "../../../PanelConstants";
import {Messages} from "../../../../Messages";
import {UsingCardComponent} from "../payment-method/components/UsingCardComponent";
import {PayWithAddedCardComponent} from "../payment-method/components/PayWithAddedCardComponent";
import {paymentMethodController} from "../../../inline-donation/PaymentMethodController";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {AddNewOrLoadCardComponent} from "../payment-method/components/AddNewOrLoadCardComponent";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";


export class PaymentAndDonationPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    panelPage = this.themeProps.INLINE_DONATE_FLOW_PAGE;

    @styleRule
    cardComponent = {
        marginBottom: 24,
    };
}

@registerStyle(PaymentAndDonationPanelStyle)
export class PaymentAndDonationPanel extends BasePanelPage {
    forceAddCard = false;
    allowRedraw = true;

    isButtonDisabled() {
        return !donateMobileState.isValid() || !this.cardComponent?.isValid();
    }

    donate() {
        this.allowRedraw = false;
        LoadingSpinner.show();

        this.cardComponent.getPaymentMethodId(paymentMethodController.getScope(), paymentMethodId => {
            if (iFrameMerchantService.isCDSPaymentMethod()) {
                paymentMethodController.update({selectedPaymentMethod: paymentMethodId});
            } else {
                paymentMethodController.update({selectedPaymentMethod: PaymentMethodStore.get(paymentMethodId)});
            }
            donateMobileState.donateInlineFlowDonateDonate();
        }, () => {
            LoadingSpinner.hide();
            this.allowRedraw = true;
            this.redraw();
        });
    }

    redraw() {
        if (this.allowRedraw) {
            super.redraw();
        }
    }

    render() {
        const {styleSheet} = this;
        if (!paymentMethodController.selectedPaymentMethod) {
            paymentMethodController.selectedPaymentMethod = PaymentMethodStore.getPrimary() || PaymentMethodStore.getAvailablePaymentMethods()[0];
            paymentMethodController.initialPaymentMethod = paymentMethodController.selectedPaymentMethod;
        }
        let cardSection;
        if (!paymentMethodController.selectedPaymentMethod && iFrameUserDataService.getExtraPaymentMethodCount() > 0 && !this.forceAddCard && !iFrameMerchantService.isCDSPaymentMethod()) {
            cardSection = <AddNewOrLoadCardComponent onAddCard={() => {
                this.forceAddCard = true;
                this.redraw();
            }} />;
        } else {
            const CardSectionClass = paymentMethodController.selectedPaymentMethod && !iFrameMerchantService.isCDSPaymentMethod()
                ? UsingCardComponent : PayWithAddedCardComponent;
            cardSection = <CardSectionClass card={paymentMethodController.selectedPaymentMethod} changeCardMessage={Messages.edit}
                                            onChange={() => this.redraw()} ref="cardComponent"
                                            onChangeCard={() => {
                                                paymentMethodController.initialPaymentMethod = paymentMethodController.selectedPaymentMethod;
                                                Router.changeURL(INLINE_DONATION_URLS.card);
                                            }}
                                            className={styleSheet.cardComponent} />;
        }

        return [
            cardSection,
            <DonateComponent ref="donateComponent" onChange={() => this.redraw()}/>,
            <MerchantButton disabled={this.isButtonDisabled()} onClick={() => this.donate()}
                            className={styleSheet.button}>
                {
                    // We use the string because of a weird safari bug where the first click isn't perceived.
                    donateMobileState.getDonateComponentButtonLabel().toString()
                }
            </MerchantButton>,
        ]
    }

    onMount() {
        super.onMount();
        this.redraw(); // This is for the first rendering where the button doesn't have a label.
        this.attachChangeListener(PaymentMethodStore, () => this.redraw());
    }
}
